import React, { useContext, useState } from 'react';
import { func } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames/bind';
import { I_DONT_KNOW } from '../../../constants';
import CarPickerContext from '../../../context/CarPickerContext';
import { LoopOverHooks } from './LoopOverHooks';
import styles from '../../car-picker.module.scss';
// eslint-disable-next-line max-len
import { CarPickerDropDownWithSearchMobile } from '../car-picker-dropdown-with-search-mobile/car-picker-dropdown-with-search-mobile';

const classes = classNames.bind(styles);

export const CarPickerData = ({ children }) => {

  const {
    fitmentOptions,
    getStaticDropDownOptions,
    dynamicOptionTypes,
    filter,
    selectedOption,
    pageType,
    dispatch
  } = useContext(CarPickerContext);
  const setSelectedOptions = ({ encodedId, value, optionType, camelCaseOption }) => {
    dispatch({
      action: 'SET_SELECTED_OPTIONS',
      value: {
        ...selectedOption,
        [optionType]: { id: encodedId, displayValue: value, option: camelCaseOption }
      }
    });
  };

  const [dynamic, setDynamic] = useState({});

  function refreshOptions(DROPDOWN_TYPE, item) {
    const { id, value, option, index } = item;
    getStaticDropDownOptions({
      newFilter: { [option]: id },
      currentDropDown: DROPDOWN_TYPE,
      id,
      value,
      option,
      index
    });
    if (DROPDOWN_TYPE !== 'MODEL') {
      setDynamic({});
    }
  }

  const { channel } = useContext(ExperienceContext);
  const isPip = pageType === 'pip';
  const isMobile = channel === 'mobile';
  const isPlpDesktop = !isPip && !isMobile;

  let dropDownClasses = classes('car-picker-dynamic-dropdown', {
    'car-picker-dynamic-dropdown--browse-and-search': isPlpDesktop
  });

  const desktopArray = [
    ...['YEAR', 'MAKE', 'MODEL'].map((optionType) => ({
      optionType,
      optionValue: `${optionType.charAt(0)}${optionType.slice(1).toLowerCase()}`,
      onSelect: (item) => refreshOptions(optionType, item),
      options: fitmentOptions[optionType] || [],
      classes: classes('car-picker-static-dropdown', {
        'car-picker-static-dropdown--browse-and-search': isPlpDesktop,
        'car-picker-static-dropdown__disabled': !fitmentOptions[optionType]?.length
      })
    })),
    ...dynamicOptionTypes.filter(({ id }) => {
      const optionType = id?.toUpperCase();
      return dynamic[optionType]?.length;
    }).map(({ id, value }) => {
      const optionType = id?.toUpperCase();
      return {
        optionType,
        optionValue: value,
        onSelect: ({ id: encodedId, value: val }) => {
          setSelectedOptions({ encodedId, value: val, optionType, camelCaseOption: id });
        },
        options: [{
          id: '',
          option: id,
          value: I_DONT_KNOW,
          __typename: 'Option'
        }, ...dynamic[optionType]],
        classes: dropDownClasses
      };
    })
  ];
  const mobileObject = isMobile && desktopArray.reduce((map, { optionType, optionValue, options }) => {
    const label = (
      <span>{selectedOption[optionType]?.displayValue
        ? selectedOption[optionType].displayValue.replace(/pick your/i, '')
        : optionValue}
      </span>
    );
    map.set(label,
      options.length ? (
        <CarPickerDropDownWithSearchMobile
          selectOption={`Select ${optionValue}...`}
          items={options.map((model) => model.value)}
          onChoose={(text) => {
            const index = fitmentOptions[optionType]?.findIndex((op) => op.value === text);
            if (typeof index !== 'undefined' && index > -1) {
              const { id, option, value } = fitmentOptions[optionType][index];
              refreshOptions(optionType, { id, index, option, value });
            } else if (text === I_DONT_KNOW) {
              setSelectedOptions({ encodedId: '', value: text, optionType });
            } else {
              const { id, option } = dynamic[optionType].find((obj_) => obj_.value === text);
              setSelectedOptions({ encodedId: id, value: text, optionType, camelCaseOption: option });
            }
          }}
        />
      ) : null);

    return map;
  }, new Map());

  return (
    <>
      {selectedOption?.MODEL?.displayValue !== 'Pick Your Model' && dynamicOptionTypes.map(({ id }) => (
        <LoopOverHooks
          key={id}
          id={id}
          filter={filter}
          onDataAvailable={((key, options) => {
            if (options.length === 1) {
              const { id: encodedId, value, option: camelCaseOption } = options[0];
              setSelectedOptions({
                optionType: key,
                encodedId,
                value,
                camelCaseOption
              });
            }
            setDynamic((prevDynamic) => ({ ...prevDynamic, [key]: options }));
          })}
        />
      )
      )}

      {children(desktopArray, mobileObject, selectedOption)}
    </>
  );

};

CarPickerData.propTypes = {
  children: func.isRequired
};
